const styles = {
  topContainer: {display: 'flex', flexDirection: 'row', alignItems: 'center'},
  inputRow: {display: 'flex', gap: '2%', justifyContent: 'stretch', alignItems: 'center'},
};

export default styles;
